import { Text } from '@mantine/core';

interface JournalVolumeProps {
  volume: string | null;
  volumeNo: string | null;

  startPage: number | null;
  endPage: number | null;
  noOfPages: number | null;
}

export function JournalVolume(props: JournalVolumeProps) {
  const { volume, volumeNo, startPage, endPage, noOfPages } = props;
  return (
    <Text size="sm">
      {' '}
      Vol {volume}({volumeNo}), Pagini:{' '}
      {(startPage || endPage) && `${startPage ?? '?'}-${endPage ?? '?'} (${noOfPages})`}
    </Text>
  );
}
